<template>
  <div class="upload-avatar">
    <div class="cropper-container position-relative d-flex justify-content-center align-items-center">
      <UploadFile
        v-show="false"
        :ref="uploadFileRef"
        @input="updateValue"
        :multiple="false"
        :uploadFileRef="uploadFileRef"
        :disabled="disabled"
        :accept="'image/jpeg, image/png'"
      />
      <div class="botoes-verticais" v-show="flagImagemCarregada">
        <div class="botao-quadrado" title="Aumentar Zoom" @click="zoom(1.5)">
          <i class="fas fa-search-plus text-info"></i>
        </div>
        <div class="botao-quadrado" title="Diminuir Zoom" @click="zoom(0.7)">
          <i class="fas fa-search-minus text-info"></i>
        </div>
        <div class="botao-quadrado" title="Centralizar" @click="center()">
          <i class="fa fa-align-center text-info"></i>
        </div>
        <div class="botao-quadrado" title="Restaurar" @click="reset()">
          <i class="fas fa-redo text-info"></i>
        </div>
      </div>
      <cropper v-if="exibirFoto" :ref="cropperRef" class="cropper"
        :src="fotoParaPrevisao"
        :transitions="true"
        :debounce="true"
        :resize-image="{
          adjustStencil: adjustStencil
        }"
        :stencil-props="{
          aspectRatio: 10/12,
          movable: true,
          resizable: true
        }"
        :background-wrapper-component="$options.components.CustomBackgroundWrapper"
        @ready="ready"
        :default-size="defaultSize"
        image-restriction="none"
        stencil-component="circle-stencil"
        :background-color="backgroundColor"
        ></cropper>
      <b-img v-if="exibirImagemSemFoto" class="img-fluid mb-2 text-center" rounded="circle" width="300" height="300" :src="fotoParaPrevisao" alt=""></b-img>
    </div>
    <div class="botoes-abaixo">
      <b-button class="botoes" variant="outline-primary btn-sm mt-2 mr-1" :disabled="disabled" @click="abrirComponenteUpload">Alterar</b-button>
      <b-button v-if="exibirFoto" class="botoes" variant="outline-primary btn-sm mt-2" :disabled="disabled" @click="aplicarAjustesNaImagem">Cortar</b-button>
    </div>
    <p v-if="usuarioNaoTemFoto" class="text-center">(Sem foto cadastrada)</p>
  </div>
</template>

<script>
import UploadAvatar from './js/uploadAvatar'
export default UploadAvatar
</script>

<style scoped>
@import './scss/uploadAvatar.scss';
</style>
